<template>
  <div>
    <div class="z-backdrop fixed left-0 top-0 w-screen h-screen !bg-black/50" @click="closeModal"></div>
    <div class="z-modal fixed left-0 w-full h-full"
				 :class="isInSidebar && window.size.desktop ? 'top-20' : 'top-0 xl:absolute'"
				 @click="closeModal()">
      <div class="bg-zt-dark border border-zt-light rounded-zt w-full
           xl:absolute xl:left-1/2 xl:-translate-x-1/2 xl:translate-y-[39px] xl:h-[434px] xl:w-[412px]"
		      :class="[
		        { 'translate-y-[32px] h-[calc(100%-32px)]': isUserWithAdminPanel && window.size.mobile },
		        { 'h-full': !isUserWithAdminPanel && window.size.mobile }
		      ]"
		      style="box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.1), 0px 4px 4px 0px rgba(0, 0, 0, 0.09), 0px 9px 5px 0px rgba(0, 0, 0, 0.05), 0px 16px 6px 0px rgba(0, 0, 0, 0.01), 0px 25px 7px 0px rgba(0, 0, 0, 0)"
		      @click.stop >
        <div class="h-[51px] w-full flex items-center py-3.5 pl-3 pr-12 top-0 border-b border-[#313A44] relative">
          <div class="flex items-center gap-3">
            <div class="w-[25px] h-[25px]">
              <div v-if="Number(isBookieDataLoaded !== 0)"
									 class="w-full h-full bg-cover" 
                   :style="{ backgroundImage: `url(/wp-content/themes/zawodtyper/assets/images/bukmacherzy/logo_${bookieData.name.toLowerCase().replaceAll(' ', '')}_kod_promocyjny.svg` }"></div>
            </div>
            <span class="text-base font-semibold">{{ bookieData.label ?? bookieData.name }}</span>
          </div>
          <div class="x-close-modal" @click.stop="closeModal"></div>
        </div>
        <div class="flex flex-col justify-between overflow-x-hidden overflow-y-auto h-[calc(100%-51px)] py-4">
	        <div v-if="isLoading || Number(isBookieDataLoaded === 0)" class="w-full h-full pl-[15px] flex flex-col justify-center items-center mt-5">
		        <svg class=" w-8 h-8 animate-spin fill-zt-red" viewBox="0 0 100 101">
			        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
			        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
		        </svg>
		        <span class="mt-4 animate-bounce">Ładowanie bonusu</span>
	        </div>
	        <div v-else class="flex-1">
	          <div class="flex-1 flex flex-col mx-5 xl:w-[370px]">
	            <div class="flex flex-col items-center mb-6">
	              <span class="text-[30px] font-bold">
	                {{ isMainBonus ? bookieData.amount : selectedBonusData.other_bonuses_data.bonus_amount }}
	              </span>
	              <span class="font-medium uppercase opacity-70 text-center">
	                {{ isMainBonus ? bookieData.amount_title : selectedBonusData.other_bonuses_data.bonus_name }}
	              </span>
	            </div>
		          <button v-if="!isMainBonus && selectedBonusData.other_bonuses_data.bonus_link"
		                  class="h-[44px] bg-zt-red rounded-zt text-sm font-medium zt-hover mx-auto mb-[22px] w-[252px]
	                    xl:w-[153px]"
		                  @click="handleCollectBonusClick(selectedBonusData.other_bonuses_data.bonus_link)">ODBIERZ BONUS</button>
		          <button v-else-if="isMainBonus && bookieData.link"
		                  class="h-[44px] bg-zt-red rounded-zt text-sm font-medium zt-hover mx-auto mb-[22px] w-[252px]
	                    xl:w-[153px]"
		                  @click="handleCollectBonusClick(bookieData.link)">ODBIERZ BONUS</button>
	            <div v-if="isMainBonus && bookieData.main_bonus_conditions"
	                 v-for="(item, index) in bookieData.main_bonus_conditions" :key="item.main_bonus_condition">
	              <span class="text-sm font-light text-[#EEE] tracking-[0.42px]">
	                {{ (index + 1) + '. ' + item.main_bonus_condition }}
	              </span>
	              <hr class="border-t border-zt-light !my-2.5 !p-0" />
	            </div>
	            <div v-else-if="!isMainBonus && selectedBonusData.other_bonuses_data.bonus_conditions"
	                 v-for="(item, index) in selectedBonusData.other_bonuses_data.bonus_conditions" :key="item.bonus_condition">
	              <span class="text-sm font-light text-[#EEE] tracking-[0.42px]">
	                {{ (index + 1) + '. ' + item.bonus_condition }}
	              </span>
	              <hr class="border-t border-zt-light my-2.5" />
	            </div>
	          </div>
	          <div v-if="!isMainBonus && selectedBonusData.other_bonuses_data.bonus_rules"
	               class="flex flex-col items-center gap-2 mx-5 mt-1 xl:w-[370px]">
	            <span class="text-xs text-zt-more">REGULAMIN</span>
	            <div class="w-full flex flex-col gap-2 border border-zt-light rounded-zt p-3.5 text-xs text-zt-more font-light">
	              <div v-for="item in selectedBonusData.other_bonuses_data.bonus_rules" :key="item.bonus_rule"
	                   class="flex gap-2.5">
	                <svg class="min-w-[6px] mt-[5px]" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
	                  <circle cx="3" cy="3" r="3" fill="#93A3BA"/>
	                </svg>
	                <span>{{ item.bonus_rule }}</span>
	              </div>
	            </div>
	          </div>
	          <div v-else-if="isMainBonus && bookieData.main_bonus_rules"
	               class="flex flex-col items-center gap-2 mx-5 mt-1 xl:w-[370px]">
	            <span class="text-xs text-zt-more">REGULAMIN</span>
	            <div class="w-full flex flex-col gap-2 border border-zt-light rounded-zt p-3.5 text-xs text-zt-more font-light">
	              <div v-for="item in bookieData.main_bonus_rules" :key="item.main_bonus_rule"
	                   class="flex gap-2.5">
	                <svg class="min-w-[6px] mt-[5px]" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
	                  <circle cx="3" cy="3" r="3" fill="#93A3BA"/>
	                </svg>
	                <span>{{ item.main_bonus_rule }}</span>
	              </div>
	            </div>
	          </div>
	        </div>
	        <button class="px-4 py-3 mx-5 mt-6 -mb-1 bg-zt-light border-zt-light rounded-zt zt-hover xl:w-[370px]"
	                @click.stop="closeModal()">
		        <span class="text-sm font-semibold">ZAMKNIJ OKNO</span>
	        </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';

export default {
  name: 'BonusDetailsModal',
  inject: ['WP'],
  mixins: [utils_mixin],
  emits: ['close-modal'],
  data() {
    return {
      isUserWithAdminPanel: false,
	    isLoading: true,
    };
  },
  props: {
    selectedBonusData: Object,
    bookieData: Object,
    isMainBonus: Boolean,
		isBookieDataLoaded: Number,
		isInSidebar: Boolean
  },
  mounted() {
    this.isUserWithAdminPanel = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor';
	  setTimeout(() => {
		  this.isLoading = false;
	  }, 500);
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    handleCollectBonusClick(link) {
      axios.post(WP.ajaxUrl, {
        endpoint: 'api_count_outerlink_click',
        link: link,
      });
      window.open(link, '_blank');
    },
  }
};
</script>
